import ResearchColumns from './researchColumns'
export default ResearchColumns
